import {REPORT_ALL_ORGANIZATION_CLIENTS} from '/enum/records.enum';

export default {
  reportName: REPORT_ALL_ORGANIZATION_CLIENTS,
};
